export class MandatorModel {
    mandatorId: number = 0;
    companyId: number = 0;
    typeDocumentId: number = 0;
    document: string = '';
    digitVerification: number = 0;
    businessName: string = '';
    percentage: number = 0;
    createDate: string = '';
    userNameCreate: string = '';
    updateDate: string | null = null;
    userNameUpdate: string | null = null;
}
